module.exports = __webpack_public_path__ + "static/media/adrecord.dbfee2b2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/adrecord.svg
// module id = 24
// module chunks = 0